// extracted by mini-css-extract-plugin
export default {"slider":"Carprop_slider__ErDSK","bbs":"Carprop_bbs__nCSZ4","sli":"Carprop_sli__CqAU9"};